








































































import APP_CONST from '@/constants/AppConst'
import ElementLabelComponent from './ElementLabelComponent'
export default ElementLabelComponent
